<template>
  <div class="container center title-section">
    <div style="height: 200px">
      <img src="../assets/images/birds.png" class="birds" alt="" v-reveal />
    </div>
    <h1 v-reveal="100">{{ content.sections.titlePage.title }}</h1>
    <h2
      v-for="(text, index) in content.sections.titlePage.text"
      :key="index"
      v-reveal="160 + index * 60"
    >
      {{ text }}
    </h2>
  </div>
  <faded-background :image="'beach_3.jpg'"></faded-background>
  <page-section :content="content.sections.do"></page-section>
</template>

<script>
import content from "../content.js";
import FadedBackground from "../components/background/FadedBackground.vue";
import Section from "../components/section/Section.vue";
import shared from "../components/shared";

export default {
  name: "app",
  components: {
    "page-section": Section,
    "faded-background": FadedBackground,
  },
  data() {
    return { content };
  },
  methods: {
    onLinkClick(link) {
      shared.onLinkClick(link);
    },
  },
};
</script>
